import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Select from './select';
import useStateManager from './use-state-manager';

/**
 * __StateManagedSelect__
 *
 * A state managed select {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */

var StateManagedSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, baseSelectProps));
});
export default StateManagedSelect;